/* eslint-disable jsx-a11y/anchor-is-valid */
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { Table, Button, Select, Input } from 'antd';
import { getWorkspace } from 'pages/LoginPage/thunk';
import { FC, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { getDataStoreFieldMachine } from '../thunk';

const { Option } = Select;

type DataType = {
  machine_type?: string;
  machine_serial_number?: string;
  machine_other?: string;
  machine_remark?: string;
};
type EditableTableState = {
  dataSource: DataType[];
  setData: any;
};

const TableAdd: FC<EditableTableState> = (props) => {
  const dispatch = useDispatch();
  const { currentApplicationId } = useSelector((state: RootState) => state.workSpaces);

  useEffect(() => {
    dispatch(getWorkspace());
  }, [dispatch]);

  useEffect(() => {
    currentApplicationId &&
      dispatch(getDataStoreFieldMachine({ appId: currentApplicationId, dataStoreId: 't_machine' }));
  }, [dispatch, currentApplicationId]);

  const { dataStoreMachineFields } = useSelector((state: RootState) => state.machineequipment);

  const optionMachineType = useMemo(() => {
    return (
      dataStoreMachineFields?.find(([_key, value]: [string, any]) => value.display_id === 'machine_type')[1].options ||
      []
    );
  }, [dataStoreMachineFields]);

  const FillDataTable = () => {
    const newData = {
      machine_type: '',
      machine_serial_number: '',
      machine_other: '',
    };
    props.setData([...props.dataSource, newData]);
  };
  const handleDelete = (record: any) => {
    const index = props.dataSource.indexOf(record);
    const arrayAfterDelete = [...props.dataSource];
    if (index > -1) {
      arrayAfterDelete.splice(index, 1);
      props.setData(arrayAfterDelete);
    }
  };

  return (
    <div>
      <Table
        rowKey="machine_id"
        columns={[
          {
            title: '',
            dataIndex: 'machine_id',
            key: 'machine_id',
            width: '6%',
            align: 'right',
            render(text: string, row: any, index: any) {
              return {
                props: {
                  style: { textAlign: 'right' },
                  className: 'standardFont',
                },
                children: <div>{index + 1}</div>,
              };
            },
          },
          {
            title: '機種',
            dataIndex: 'machine_type',
            key: 'machine_type',
            align: 'left',
            render(text: string, row: any, index) {
              return {
                props: {
                  style: { textAlign: 'left' },
                  className: 'standardFont',
                },
                children: (
                  <div>
                    <Select
                      value={text}
                      onChange={(e) => {
                        const newData = props.dataSource.map((item) => {
                          if (props.dataSource.indexOf(item) === index) {
                            return {
                              ...item,
                              machine_type: e,
                            };
                          }
                          return item;
                        });
                        props.setData(newData);
                      }}
                      style={{ width: '12rem' }}
                      size={'large'}
                    >
                      {optionMachineType.map((g: any, i: number) => (
                        <Option key={i} value={g.display_id}>
                          {g.value}
                        </Option>
                      ))}
                    </Select>
                  </div>
                ),
              };
            },
          },
          {
            title: '',
            dataIndex: 'machine_other',
            key: 'machine_other',
            align: 'left',
            render(text: string, row: any, index: any) {
              return {
                props: {
                  style: { textAlign: 'left' },
                  className: 'standardFont',
                },
                children: (
                  <div>
                    <Input
                      size={'large'}
                      style={{ width: '12rem' }}
                      value={text}
                      disabled={props.dataSource[index].machine_type === 'o_other' ? false : true}
                      onChange={(e) => {
                        const newData = props.dataSource.map((item) => {
                          if (props.dataSource.indexOf(item) === index) {
                            return {
                              ...item,
                              machine_other: e.target.value,
                            };
                          }
                          return item;
                        });
                        props.setData(newData);
                      }}
                    />
                  </div>
                ),
              };
            },
          },
          {
            title: 'シリアルナンバー',
            dataIndex: 'machine_serial_number',
            key: 'machine_serial_number',
            align: 'left',
            render(text: string, row: any, index: any) {
              return {
                props: {
                  style: { textAlign: 'left' },
                  className: 'standardFont',
                },
                children: (
                  <div>
                    <Input
                      style={{ width: '12rem' }}
                      size={'large'}
                      value={text}
                      onChange={(e) => {
                        const newData = props.dataSource.map((item) => {
                          if (props.dataSource.indexOf(item) === index) {
                            return {
                              ...item,
                              machine_serial_number: e.target.value,
                            };
                          }
                          return item;
                        });
                        props.setData(newData);
                      }}
                      autoComplete={`${Math.random()}`}
                    />
                  </div>
                ),
              };
            },
          },
          {
            title: '備考',
            dataIndex: 'machine_remark',
            key: '',
            align: 'left',
            render(text: string, record: any, index: number) {
              return {
                props: {
                  style: { textAlign: 'left' },
                  className: 'standardFont',
                },
                children: (
                  <div>
                    <Input
                      style={{ width: '12rem' }}
                      size={'large'}
                      value={text}
                      onChange={(e) => {
                        const newData = props.dataSource.map((item) => {
                          if (props.dataSource.indexOf(item) === index) {
                            return {
                              ...item,
                              machine_remark: e.target.value,
                            };
                          }
                          return item;
                        });
                        props.setData(newData);
                      }}
                      autoComplete={`${Math.random()}`}
                    />
                  </div>
                ),
              };
            },
          },
          {
            title: '',
            dataIndex: '',
            key: '',
            align: 'left',
            render(text: string, record: any) {
              return {
                props: {
                  style: { textAlign: 'left' },
                  className: 'standardFont',
                },
                children: (
                  <div>
                    {props.dataSource.length > 1 ? (
                      <a onClick={() => handleDelete(record)}>
                        <DeleteOutlined style={{ width: '17px', height: '17px', color: 'black' }} />
                      </a>
                    ) : null}
                  </div>
                ),
              };
            },
          },
        ]}
        dataSource={props.dataSource}
        pagination={false}
      />
      <div style={{ textAlign: 'center' }}>
        <Button
          onClick={FillDataTable}
          style={{
            borderRadius: '21.5px',
            background: '#ff8a00',
            border: 'none',
            color: 'white',
            padding: '11px 32px 30px 30px',
            marginTop: '30px',
          }}
        >
          <PlusOutlined /> 追加
        </Button>
      </div>
    </div>
  );
};

export default TableAdd;
